// case
export default {
	getAdminPages(state) {
		return state.admin.pages
	}
}
